import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

// TODO: current 16px variation uses multiple `d` tags
const draw24px =
  'M9.59,14.27v3.3l2.51.72V20L2.56,17.1V14.77l9.54-3.06v1.77ZM8.22,17.18v-2.5L3.76,15.94ZM5.83,5.31A2.79,2.79,0,0,1,7,4.35,4.64,4.64,0,0,1,8.83,4H9a3.74,3.74,0,0,1,1.65.37,3,3,0,0,1,1.23,1.09A2.65,2.65,0,0,1,12.28,7a2.55,2.55,0,0,1-.79,1.89L12.1,9v1.32H2.56V8.64H6.15A2.48,2.48,0,0,1,5.4,6.76,2.48,2.48,0,0,1,5.83,5.31Zm2.95.39c-1.4,0-2.1.47-2.1,1.4A1.87,1.87,0,0,0,6.89,8a1.8,1.8,0,0,0,.57.66h3A1.84,1.84,0,0,0,11,7.25a1.34,1.34,0,0,0-.55-1.13A2.56,2.56,0,0,0,8.88,5.7ZM22,6.66,18.77,3.47a.75.75,0,0,0-1.06,0L14.52,6.66a.75.75,0,0,0,.53,1.28h2.44V20A.75.75,0,0,0,19,20V7.94h2.44a.74.74,0,0,0,.69-.46A.76.76,0,0,0,22,6.66Z';

const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextOrientationVerticalUpIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'textOrientationVerticalUp')) as IconWithRender;

TextOrientationVerticalUpIcon.displayName = 'TextOrientationVerticalUpIcon';
TextOrientationVerticalUpIcon.propTypes = Icon.propTypes;
TextOrientationVerticalUpIcon.renderIcon = (props) => (
  <TextOrientationVerticalUpIcon {...props} />
);
export default TextOrientationVerticalUpIcon;
